// BA 智慧大樓 API

/**
 * @function ApiClient#GetBAConnectionList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetBAConnectionList(cid, options = {}) {
  return await this._get(`/community/${cid}/ba/connection_list`, options);
}

/**
 * @function ApiClient#AddBAConnection
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddBAConnection(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ba/connection`, data, options);
}

/**
 * @function ApiClient#UpdateBAConnection
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateBAConnection(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ba/connection`, data, options);
}

/**
 * @function ApiClient#DeleteBAConnection
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} connId
 * @param {any} options = {}
 */
export async function DeleteBAConnection(cid, connId, options = {}) {
  return await this._delete(`/community/${cid}/ba/connection/${connId}`, options);
}

/**
 * @function ApiClient#GetBADeviceTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetBADeviceTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/ba/device_type_list`, options);
}

/**
 * @function ApiClient#AddBADeviceType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddBADeviceType(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ba/device_type`, data, options);
}

/**
 * @function ApiClient#UpdateBADeviceType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateBADeviceType(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ba/device_type`, data, options);
}

/**
 * @function ApiClient#DeleteBADeviceType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} tid
 * @param {any} options = {}
 */
export async function DeleteBADeviceType(cid, tid, options = {}) {
  return await this._delete(`/community/${cid}/ba/device_type/${tid}`, options);
}

/**
 * @function ApiClient#GetBADeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.typeKey
 * @param {any} params.name
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetBADeviceList(cid, { typeKey = "", name = "", page = 1, perPage = 15 } = {}, options = {}) {
  return await this._get(`/community/${cid}/ba/device_list?typeKey=${typeKey}&name=${encodeURIComponent(name)}&p=${page}&pp=${perPage}`, options);
}

/**
 * @function ApiClient#AddBADevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddBADevice(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ba/device`, data, options);
}

/**
 * @function ApiClient#GetBADevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function GetBADevice(cid, did, options = {}) {
  return await this._get(`/community/${cid}/ba/device/${did}`, options);
}

/**
 * @function ApiClient#UpdateBADevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateBADevice(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ba/device`, data, options);
}

/**
 * @function ApiClient#DeleteBADevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function DeleteBADevice(cid, did, options = {}) {
  return await this._delete(`/community/${cid}/ba/device/${did}`, options);
}

/**
 * @function ApiClient#SeedBADevices
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SeedBADevices(cid, options = {}) {
  return await this._post(`/community/${cid}/ba/devices/seed`, {}, options);
}

/**
 * @function ApiClient#GetBASnapshotSummary
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetBASnapshotSummary(cid, options = {}) {
  return await this._get(`/community/${cid}/ba/snapshot_summary`, options);
}

/**
 * @function ApiClient#GetBASnapshotByModule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} moduleId
 * @param {any} options = {}
 */
export async function GetBASnapshotByModule(cid, moduleId, options = {}) {
  return await this._get(`/community/${cid}/ba/snapshot/${moduleId}`, options);
}

/**
 * @function ApiClient#SendBAControl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SendBAControl(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ba/control`, data, options);
}
